// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"da588c0a","615":"3e5e68db"}[chunkId] + ".chunk.css";
};